
const contentview = [{"key":"contentview.title","string":"Zawartość, którą dodałeś\/aś do repozytorium wiedzy"},{"key":"contentview.add_content_button","string":"Dodaj zawartość"},{"key":"contentview.no_content_added","string":"Dotychczas nie dodałeś\/aś rzadnej zawartości do repozytorium wiedzy."},{"key":"contentview.table.title","string":"Tytuł"},{"key":"contentview.table.author","string":"Autor"},{"key":"contentview.table.year","string":"Rok"},{"key":"contentview.full_text","string":"Przejdź do pełnego tekstu"}]

export default contentview



// WEBPACK FOOTER //
// ./src/i18n/pl/addcontent/contentview.js